import React, { useContext, useRef, useState } from 'react'
import './Helpcontents.css'
import call from "../../imgs/call.webp";
import mail from "../../imgs/mail.png";
import Globalcontext from '../../Context/Globalcontext';

import { useTranslation } from "react-i18next";

const Helpcontents = (props) => {
  const [mastermenu, setMastermenu] = useState(true);
  const [showBackImage, setShowBackImage] = useState(false);
  const [transitionEnded, setTransitionEnded] = useState(true);
  const [kopen, setkopen] = useState(0);

  const { submenu, setsubmenu, setHeadname } = useContext(Globalcontext);

  const [dialog, setDialog] = useState({
    message: "",
    isLoading: false,
    nameProduct: ""
  });

  const [t] = useTranslation();

  const handleTransitionEnd = () => {
    if (!mastermenu) setShowBackImage(true);
    else setShowBackImage(false);
    setTransitionEnded(true);
  };

  return (
    <>
      <div className='line' />
      <div className="maincon">
        <div className="rowreport">
          <div className="helpfirst">
            <div className='helpmain'>
              <img className='smallimg' src={call} alt="" />
              <span className="headinghelp">
                {t("help.software_help")} - (+91) 800-788-9200
              </span>
            </div>

            <div className='helpmain'>
              <img className='smallimg' src={mail} alt="" />
              <span className="headinghelp">support@idairy.co.in</span>
            </div>
          </div>
        </div>

        <div className={`rowbox ${mastermenu ? '' : 'hidden'}`}>
          <div className="first"></div>
          <div className="second">
            <div className='line' />
            <span className='firstspan'>{t("help.info.1")}</span>
            <span className='infospan'>{t("help.info.2")}</span>
          </div>
        </div>
      </div>
    </>
  )
}

export default Helpcontents;
